import { enterpriseApiSlice } from "./index";
import { ChSummaryResponse, ChDrilldownResponse } from "../Model/Api/ChAnalyticsObjects";

export const chAnalyticsApi = enterpriseApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        fetchChSummary: builder.query({
            query: ({ timeframe, startDate, endDate, onTimeBufferMinutes = 0 }) => {
                const bufferParam = onTimeBufferMinutes > 0 ? `onTimeBufferMinutes=${onTimeBufferMinutes}` : "";
                if (timeframe === "range" && startDate && endDate) {
                    const qs = [`startDate=${startDate}`, `endDate=${endDate}`, bufferParam].filter(Boolean).join("&");
                    return {
                        url: `/admin/analytics/ch/v2/summary/range?${qs}`,
                        method: "GET",
                    };
                }
                return {
                    url: `/admin/analytics/ch/v2/summary/${timeframe}${bufferParam ? `?${bufferParam}` : ""}`,
                    method: "GET",
                };
            },
            extraOptions: { auth: true },
            transformResponse: (response) => new ChSummaryResponse(response),
            keepUnusedDataFor: 30,
        }),
        fetchChDrilldown: builder.query({
            query: ({ companyId, metric, timeframe, startDate, endDate, page = 1, pageSize = 25, exportAll = false, onTimeBufferMinutes = 0 }) => {
                const params = new URLSearchParams({
                    companyId: String(companyId),
                    metric: metric.toUpperCase(),
                    timeframe,
                    page: String(page),
                    pageSize: String(pageSize),
                });
                if (startDate) params.append("startDate", startDate);
                if (endDate) params.append("endDate", endDate);
                if (exportAll) params.set("export", "true");
                if (onTimeBufferMinutes > 0) params.append("onTimeBufferMinutes", String(onTimeBufferMinutes));
                return {
                    url: `/admin/analytics/ch/drilldown?${params.toString()}`,
                    method: "GET",
                };
            },
            extraOptions: { auth: true },
            transformResponse: (response) => new ChDrilldownResponse(response),
            keepUnusedDataFor: 0,
        }),
    }),
    overrideExisting: false,
});

export const {
    useFetchChSummaryQuery,
    useFetchChDrilldownQuery,
    useLazyFetchChDrilldownQuery,
} = chAnalyticsApi;
